import { isValidDate } from '../create/create-ts-date';
import { absFloor } from '../utils/utils';
function diffByUnits(unitsInMs) {
    return function (d1, d2) {
        if (!isValidDate(d1) || !isValidDate(d2))
            return null;
        return absFloor((d1.getTime() - d2.getTime()) / unitsInMs);
    };
}
export var diffMilliseconds = diffByUnits(1 /* Milliseconds */);
export var diffSeconds = diffByUnits(1000 /* Seconds */);
export var diffMinutes = diffByUnits(60000 /* Minutes */);
export var diffHours = diffByUnits(3600000 /* Hours */);
function dateToArray(d) {
    return [d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()];
}
function compareArrays(list1, list2, fromPosition) {
    for (var i = fromPosition; i < list1.length; i++) {
        if (list1[i] === list2[i])
            continue;
        return list1[i] > list2[i] ? 1 : -1;
    }
    return 0;
}
export var diffDate = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
    var utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
    var diff = absFloor((utc1 - utc2) / 86400000 /* Date */);
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 3);
    if (diffTail === 0 || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
};
export var diffMonth = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var diff = (d1.getFullYear() - d2.getFullYear()) * 12 + d1.getMonth() - d2.getMonth();
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 2);
    if (diffTail === 0 || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
};
export var diffYear = function (d1, d2) {
    if (!isValidDate(d1) || !isValidDate(d2))
        return null;
    var diff = d1.getFullYear() - d2.getFullYear();
    if (diff === 0)
        return 0;
    var diffTail = compareArrays(dateToArray(d1), dateToArray(d2), 1);
    if (!diffTail || diff > 0 === diffTail > 0)
        return diff;
    return diff + diffTail;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-date/esm/src/diff/diff-unit.js
// module id = null
// module chunks = 